<crm-model-driven-form
  [objectType]="objectType"
  (formSubmit)="onSave($event)"
  (formCancel)="onCancel()"
  [submitButtonText]="'ACTIONS.SAVE' | translate"
  [cancelButtonText]="'ACTIONS.CANCEL' | translate"
  [loadingStatus]="loadingStatus()"
  [savingStatus]="savingStatus()"
  [fieldConfig]="(fieldConfig$ | async) || {}"
  [mode]="'basic-field-group'"
></crm-model-driven-form>
